export default __webpack_public_path__ + "static/media/board_card.708219ae.png";